import { trackOffersHistoryFiltersChange } from './tracking';
import { selectFiltersStringified } from '../../../../selectors/offersHistory';
import { TThunkAction } from '../../../../types/redux';

export const trackFiltersChange = (): TThunkAction => (_, getState) => {
  const state = getState();
  const filtersStr = selectFiltersStringified(state);

  trackOffersHistoryFiltersChange(filtersStr);
};
